export default __webpack_public_path__ + "static/media/quotes.66d75555.svg";